import React, { createContext, useContext } from 'react'

const RoleContext = createContext()

export const useRole = () => {
  return useContext(RoleContext)
}

export const RoleProvider = ({ children, value }) => {
  return <RoleContext.Provider value={value}>{children}</RoleContext.Provider>
}
